import { useTranslation } from 'react-i18next';
import { AddMemberModal } from '@/pages/Schedule/components';
import {
  useScheduleMembers,
  useScheduleMembersLimit,
} from '@/pages/Schedule/hooks';
import {
  Button,
  Flex,
  Heading,
  Icon,
  Spinner,
  Text,
  useDisclosure,
} from '@/ui';
import { RecipientsEmptyState } from '../EmptyState';
import { MembersTable } from './components/MembersTable';

export const MembersSection = () => {
  const { members, isLoading } = useScheduleMembers();
  const { t } = useTranslation('members');
  const membersLimit = useScheduleMembersLimit();

  const {
    isOpen: isAddMemberModalOpen,
    onClose: onAddMemberModalClose,
    onOpen: openAddMemberModal,
  } = useDisclosure();

  return (
    <>
      <AddMemberModal
        isOpen={isAddMemberModalOpen}
        onClose={onAddMemberModalClose}
      />

      {isLoading ? (
        <Spinner />
      ) : members.length ? (
        <Flex direction="column" flex="1">
          <Flex
            align="center"
            direction={{ base: 'column', sm: 'row' }}
            gap={{ base: 4, sm: 10 }}
            mb="14"
          >
            <Flex direction="column" flex="1" gap="4">
              <Flex align="center" flex="1" gap="4">
                <Heading fontSize={{ base: 'lg', lg: '2xl' }}>
                  {t('heading')}
                </Heading>
                {membersLimit && membersLimit.members > 0 && (
                  <Text color="gray.500" display={{ lg: 'none' }} fontSize="sm">
                    {membersLimit.members}/{membersLimit.limit}
                  </Text>
                )}
                <Button
                  leftIcon={<Icon icon="Plus" size="15px" />}
                  ml="auto"
                  size="sm"
                  onClick={openAddMemberModal}
                >
                  {t('add_recipient')}
                </Button>
              </Flex>

              <Text fontSize={{ base: 'md', lg: 'lg' }} maxW={{ lg: '400px' }}>
                {t('byline_line_one')}
              </Text>
            </Flex>
          </Flex>

          <MembersTable members={members} />
        </Flex>
      ) : (
        <RecipientsEmptyState onAddClick={openAddMemberModal} />
      )}
    </>
  );
};
